<div class="relative text-left group" [ngClass]="{'block w-full': isMobileNavbar, 'inline-block': !isMobileNavbar}">
	<button
		class="text-peps-dark-200 py-2 cursor-pointer hover:text-peps-gold transition-colors duration-300 flex items-center gap-2"
		routerLinkActive="text-peps-gold"
		[routerLink]="route ? route : null"
		[ngClass]="{'text-peps-gold': isActiveCategory}"
		(click)="handleClick()"
	>
		<span class="uppercase">{{ text }}</span>

		<svg
			class="w-4 h-4 transition-transform duration-200 fill-current"
			[ngClass]="{'rotate-180' : isOpen && isMobile, 'group-hover:rotate-180' : !isMobile}"
			viewBox="0 0 10 6" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M1.2759 0H8.7239C8.85573 2.81495e-05 8.9846 0.0391426 9.09421 0.112399C9.20381 0.185655 9.28924 0.289764 9.33969 0.411564C9.39013 0.533364 9.40333 0.667385 9.37762 0.796687C9.35191 0.925989 9.28844 1.04477 9.19523 1.138L5.47123 4.862C5.34621 4.98698 5.17668 5.05719 4.9999 5.05719C4.82312 5.05719 4.65358 4.98698 4.52857 4.862L0.804566 1.138C0.71136 1.04477 0.647889 0.925989 0.622177 0.796687C0.596466 0.667385 0.609668 0.533364 0.660114 0.411564C0.710561 0.289764 0.795987 0.185655 0.905594 0.112399C1.0152 0.0391426 1.14407 2.81495e-05 1.2759 0Z"/>
		</svg>
	</button>

	@if (isMobile && isOpen) {
		<div
			class="z-20 bg-peps-dark-700 transition duration-200 w-max min-w-full"
			[ngClass]="{'absolute': !isMobileNavbar}"
		>
			<ul>
				@for (category of items; track category.label) {
					<li class="px-4 pt-3 pb-1 text-xs text-peps-text-5 uppercase tracking-wide">{{ category.label }}</li>
					@for (item of getFilteredItems(category.items); track item.label) {
						<li>
							<button
								(click)="select(item.action)"
								class="flex items-center gap-2 px-4 py-4 w-full text-left cursor-pointer whitespace-nowrap hover:bg-peps-dark-500 transition-colors duration-300 uppercase"
							>
								{{ item.label }}
								@if (isItemBeta(item)) {
									<span class="ml-2 px-2 py-0.5 text-xs bg-orange-500 text-white rounded-full">BETA</span>
								}
							</button>
						</li>
					}
				}
			</ul>
		</div>
	}

	<div
		class="absolute -left-full invisible opacity-0 hidden group-hover:opacity-100 group-hover:visible transition duration-200 w-md bg-peps-dark-800 border border-peps-dark-600 rounded-2xl shadow-2xl shadow-black/60 p-3.5 lg:flex flex-col gap-2.5 [&_svg]:fill-current">

		<a
			href="/battlepeps"
			class="group flex flex-row items-center gap-3.5 bg-peps-gold/10 border border-peps-gold/30 rounded-lg px-4 py-3.5 hover:bg-peps-gold/20 transition-all"
		>
			<div class="flex flex-col gap-0.5 min-w-0 text-left">
				<span class="flex items-center gap-2">
					<span class="text-base font-bold uppercase tracking-wide text-peps-gold">{{ 'component.navbar.category-panel.quests.title' | translate }}</span>
					<span class="px-2.5 py-1 text-xs font-bold uppercase tracking-wide bg-peps-gold text-peps-dark-900 rounded-full leading-none">{{ 'common.new' | translate }}</span>
				</span>
				<span class="text-sm text-peps-text-5 font-notosans">{{ 'component.navbar.category-panel.quests.description' | translate }}</span>
			</div>
		</a>

		<div class="grid grid-cols-1 sm:grid-cols-2 gap-2.5">

			<div class="bg-peps-dark-700 border border-peps-dark-600 rounded-lg p-3.5 flex flex-col gap-2.5">
				<div class="flex items-center gap-2.5 pb-2.5 border-b border-peps-dark-500">
					<a href="/bet/matches" class="flex">
						<span class="text-sm font-bold uppercase  text-peps-purple">{{ 'component.navbar.category-panel.bet.title' | translate }}</span>
					</a>
				</div>
				<div class="flex flex-col gap-1">
					<a
						href="/bet/matches"
						class="group flex items-start gap-2.5 p-2.5 rounded-lg border border-transparent hover:bg-white/5 hover:translate-x-0.5 transition-all"
					>
						<span class="flex flex-col justify-center gap-0.5 min-w-0">
							<span class="text-[15px] font-semibold text-peps-text-9 uppercase">{{ 'component.navbar.category-panel.bet.make-bet.title' | translate }}</span>
				            <span class="text-[13px] leading-snug text-peps-text-5 font-notosans">{{ 'component.navbar.category-panel.bet.make-bet.description' | translate }}</span>
						</span>
					</a>
					<a
						href="/bet/leaderboard"
						class="group flex items-start gap-2.5 p-2.5 rounded-lg border border-transparent hover:bg-white/5 hover:translate-x-0.5 transition-all"
					>
						<span class="flex flex-col justify-center gap-0.5 min-w-0">
				            <span class="text-[15px] font-semibold text-peps-text-9 uppercase">{{ 'component.navbar.category-panel.bet.leaderboard.title' | translate }}</span>
				            <span class="text-[13px] leading-snug text-peps-text-5 font-notosans">{{ 'component.navbar.category-panel.bet.leaderboard.description' | translate }}</span>
			            </span>
					</a>
				</div>
			</div>

			<div class="bg-peps-dark-700 border border-peps-dark-600 rounded-lg p-3.5 flex flex-col gap-2.5">
				<div class="pb-2.5 border-b border-peps-dark-500">
					<a href="/profil" class="flex gap-2.5">
						<span class="text-sm font-bold uppercase tracking-wide text-peps-orange">{{ 'component.navbar.category-panel.collection.title' | translate }}</span>
						<span class="px-2.5 py-1 text-xs font-bold uppercase tracking-wide bg-peps-gold text-peps-dark-900 rounded-full leading-none">{{ 'common.new' | translate }}</span>
					</a>
				</div>
				<div class="flex flex-col gap-1">
					<a
						href="/collection/marketplace"
						class="group flex items-start gap-2.5 p-2.5 rounded-lg border border-transparent hover:bg-white/5 hover:translate-x-0.5 transition-all"
					>
						<span class="flex flex-col justify-center gap-0.5 min-w-0">
							<span class="text-[15px] font-semibold text-peps-text-9 uppercase">{{ 'component.navbar.category-panel.collection.marketplace.title' | translate }}</span>
							<span class="text-[13px] leading-snug text-peps-text-5 font-notosans">{{ 'component.navbar.category-panel.collection.marketplace.description' | translate }}</span>
						</span>
					</a>
					<a
						href="/collection/shop"
						class="group flex items-start gap-2.5 p-2.5 rounded-lg border border-transparent hover:bg-white/5 hover:translate-x-0.5 transition-all"
					>

						<span class="flex flex-col justify-center gap-0.5 min-w-0">
							<span class="text-[15px] font-semibold text-peps-text-9 uppercase">{{ 'component.navbar.category-panel.collection.shop.title' | translate }}</span>
							<span class="text-[13px] leading-snug text-peps-text-5 font-notosans">{{ 'component.navbar.category-panel.collection.shop.description' | translate }}</span>
						</span>
					</a>
				</div>
			</div>

		</div>

	</div>

</div>
